import React from 'react'
import { Link } from 'gatsby'
import clsx from 'clsx'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { MegaMenu } from '@/components/organisms/MegaMenu/MegaMenu'
import { removeFoldersFromUrl } from '@/helpers/removeFoldersFromUrl'
import { getCurrentLang } from '@/helpers/getCurrentLang'
import { translateContent } from '@/helpers/translateContent'
import { ReactComponent as Arrow } from '@/assets/icons/thin-arrow-purple.svg'
import { NavigationProps } from './types'
import * as styles from './DesktopNavigation.module.css'

export function DesktopNavigation({ links, simple }: NavigationProps) {
  const currentLang = (typeof window !== 'undefined' && getCurrentLang(window.location)) || 'en'
  const mainNavAriaLabel = translateContent(currentLang, 'mainNavigation')

  return (
    <nav
      aria-label={mainNavAriaLabel}
      className={clsx(
        'hidden netbook:w-full mx-8 lg:ml-32 lg:mr-12 desktop:ml-64 desktop:mr-24',
        !simple && 'netbook:block'
      )}
    >
      <ul className="flex items-center gap-12 lg:gap-24 w-auto">
        {links &&
          links.map((link) => (
            <li
              key={link._uid}
              className={clsx(
                'text-text-dark-900 hover:text-text-brand-primary text-bodyL last:lg:mr-4 ',
                links.length < 5 ? 'last:ml-0' : 'last:ml-auto',
                { 'relative ': !link.variant }, // TODO remove after updating production storyblok to new DS
                styles.dropdown
              )}
            >
              {link.dropdown_menu ? (
                <>
                  {link.link_url ? (
                    <Link to={removeFoldersFromUrl(link?.link_url?.cached_url)} className="whitespace-nowrap">
                      {link.text}
                    </Link>
                  ) : (
                    <button
                      type="button"
                      aria-expanded="false"
                      aria-controls="megamenu-dropdown"
                      className="flex items-center [&>svg]:rotate-90 [&>svg]:hover:-rotate-90 [&>svg]:transition [&>svg]:duration-300 [&>svg]:size-14 gap-4"
                    >
                      {link.text}
                      <Arrow />
                    </button>
                  )}
                  <MegaMenu menus={link.dropdown_menu} variant={link?.variant} />
                </>
              ) : (
                <CustomLink {...link}>{link.text}</CustomLink>
              )}
            </li>
          ))}
      </ul>
    </nav>
  )
}
